module.exports = __webpack_public_path__ + "static/media/PeaksGraphic.326c8a21.svg";